<template>
  <div class="pa-2 pa-sm-5 primary tco-choose-product-rules multiple-rules">
    <v-row>
      <v-col cols="3" class="d-flex align-center">
        <img
          height="100"
          width="202"
          alt="immagine sconto percentuale"
          src="/img_layout/tco/tco-discount.png"
        />
      </v-col>
      <v-col cols="6" class="d-flex align-center">
        <h2 class="d-flex flex-column flex-sm-row">
          <span class="">scegli i tuoi prodotti preferiti</span>
        </h2>
      </v-col>
      <v-col cols="3" class="d-flex flex-column">
        <div
          class="d-flex w-100 text-h2 line-height-13 pa-2"
          v-if="promoProductsTcoToChoose"
        >
          <span class="products-recap"
            >{{ promoProductsTco.length }}/{{ promoProductsTcoToChoose }}</span
          ><span class="products-recap-text pl-2">completati</span>
        </div>
        <template>
          <div class="d-flex w-100 px-2">
            <v-icon
              v-for="(product, index) in promoProductsTco"
              :key="'promo-' + index"
              class="dot-full"
              :class="{ 'px-2': index != 0 || index != 4 }"
            >
              $delimiter
            </v-icon>
            <v-icon
              v-for="index in promoProductsTcoToChoose -
                promoProductsTco.length"
              :key="'radio-off-' + index"
              class="dot-empty"
              :class="{ 'px-2': index != 0 || index != 4 }"
            >
              $radioOff
            </v-icon>
          </div>
        </template>
        <v-btn
          color="primary white--text"
          depressed
          @click="modalOpen = true"
          class="my-4"
        >
          COME FUNZIONA
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <v-dialog v-model="modalOpen" max-width="700">
        <!-- <div class="vuedl-layout__closeBtn" @click="modalOpen = false">
        ×
      </div> -->
        <v-card>
          <div
            class="pa-5 tco-block-card primary--text h-100 text-center d-flex flex-column align-center justify-space-between"
            v-if="tcoProductRules"
            v-html="tcoProductRules.content.rendered"
          ></div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn outlined color="primary" @click="modalOpen = false">
              Chiudi
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.tco-choose-product-rules {
  background-image: url("/img_layout/tco/tco-bg.png");
  height: auto;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border: 2px solid $gold;
}
.products-recap {
  font-size: 36px !important;
  display: flex;
  align-items: flex-end;
  color: var(--v-promo-darken2) !important;
}
.products-recap-text {
  display: flex;
  align-items: flex-end;
  color: var(--v-promo-darken2) !important;
  margin-bottom: 5px;
}
.dot-full,
.dot-empty {
  font-size: 14px !important;
  color: var(--v-promo-darken2) !important;
}
.tco-block-card {
  .v-expansion-panel {
    button {
      background-color: var(--v-primary-base);
      color: $white;
      .v-expansion-panel-header__icon {
        .v-icon {
          color: $white !important;
        }
      }
    }
  }
}
</style>
<script>
import cmService from "~/service/cmService";

import get from "lodash/get";

export default {
  name: "TcoChooseMultipleProductRules",
  data() {
    return {
      modalOpen: false,
      tcoProductRules: null
    };
  },
  props: {
    promoProductsTco: { type: Array, default: () => [] },
    promoProductsTcoToChoose: { type: Number, required: false }
  },
  computed: {},
  methods: {
    async loadTcoProductRulesBlock() {
      let res = await cmService.getUxBlocks("tco-gestione-sconti");
      // wp non scende block corretto?
      this.tcoProductRules = get(res, "[4]", []);
    }
  },
  mounted() {
    this.loadTcoProductRulesBlock();
  }
};
</script>
